export const BASE_ROUTE = 'bytepad';
export const BASE_APPLICATION = 'application';
export const BASE_ROUTE_MODULE = 'module';
export const BASE_ROUTE_SUB_MODULE = 'submodule';
export const BASE_ROUTE_PAD = 'pad';
export const BASE_ROUTE_WIDGETS = 'widgets';
export const BASE_RECORD_ID = 'record_id';
export const PARAMS_KEY = 'tk';
export const TRIGGER = 'trigger';
export const BASE_MENU_ITEM = 'menu_item';
export const USER_ACCESS = 'user-access';
export const AR_WORKDOWN = 'ar-workdown';
export const BI_TOOL = 'bi-tool';
export const BIIG_PORTAL = 'biig_portal';
export const BASE_LEGACY_APP = 'LegacyApp';
export const BASE_SPECIMEN_NUMBER = 'specimen_number';
export const BASE_ACCESSION_NUMBER = 'accession_number';
export const BASE_SPECIMEN_NUMBER_ID = 'specimen_number_id';
export const BASE_SPECIMEN_TYPE = 'specimen_type';
export const BASE_DEMOGRAPHIC_ID = 'BASE_DEMOGRAPHIC_ID';
export const ASSET_INFO_ID = 'ASSET_INFO_ID';
export const BASE_PROCEDURE_ID = 'BASE_PROCEDURE_ID';
export const BASE_ACCOUNT_ID = 'account_id';
export const USER_GROUPS = 'user-groups';
export const BASE_UNIQUE_ID = 'unique_id';
export const BASE_UNIQUE_TYPE='unique_type'
export const CREATE_PAD = 'create_pad';
export const IS_FROM_EPIC = 'is_from_epic';
export const MODE = 'mode';
export const LOCAL_SEARCH = 'local_search';
export const AI_BLOB_SEARCH = 'ai_blob_search';
export const SEARCH_CONTEXT = 'search_context';
export const BASE_DATA_GRID_ROW = 'base_data_grid_row';
export const MOVE_TO_TAB = 'move_to_tab';
export const LMS_TYPE = 'type';
export const LMS_MODULE_ID = 'module_id';
export const LMS_PREVIEW_ID = 'preview_id';
export const LMS_IS_ADMIN = 'is_admin';
export const INVOICE_NUMBER = 'invoice_number';
export const CHILD_TAB_NAME = 'tab_name';
export const IS_FROM_ATHENA = 'is_from_athena';
export const UAM = 'uam';
